const initialState = {
    user:""
}

export default function(state = initialState, action){
    switch(action.type){
        case "UPDATE_USER_DETAIL":
            return {
                ...state,
               user:action.data
            }
        case "UPDATE_USER_DETAIL_NOTIFICATION":
            return {
                ...state,
                user:{
                    ...state.user,
                    notification_settings:action.data
                }
            }
        default: return state
    }

}
